import {handleAuth0Login, setAuthorizationToken} from './js/auth0';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';
import {showErrorWithCode} from './components/LoginError';
import * as app from './app';

const appInit = () => Promise.resolve(app).then(({initialize}) => initialize());

document.addEventListener('DOMContentLoaded', () => {
    if (getFeatureFlag('auth0_universal_login')) {
        handleAuth0Login(appInit, showErrorWithCode);
    } else {
        setAuthorizationToken();
        appInit();
    }
});
